import styled from "@emotion/styled";
import { rem } from "polished";

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${rem(45)};
`;
